module.exports = __webpack_public_path__ + "img/user-color.c7ce8e7.png";